<script setup>
import { useRouter } from 'vue-router'
import Icon from '@martyrs/src/design-system/components/Icon/Icon.vue'

const router = useRouter()
const goBack = () => window.history.length > 1 ? router.back() : router.push('/')
</script>

<template>
  <div class="pd-thin flex flex-v-center w-100 h-100 ">
    <div class="bg-card w-100 h-100 flex flex-h-center flex-column radius-big pd-medium">

      <div class="flex flex-v-center gap-thin pd-thin radius-big bg-accent w-fit mn-b-medium">
        <span class="footnote">Error 404</span>
      </div>

      <h1 class="mn-b-semi">Page not found</h1>

      <p class="text-medium opacity-50 w-max-35r mn-b-big" style="line-height: 1.6;">
        The page you are looking for doesn't exist or has been moved. Please check the URL or navigate back to the home page.
      </p>

      <div class="flex gap-small mn-b-extra">
        <router-link to="/" class="button button--inverse t-inverse pd-regular radius-small flex flex-v-center gap-thin">
          <Icon name="home" class="i-regular" :color="'rgb(var(--text-inverse))'" />
          <span>Go home</span>
        </router-link>
        <button @click="goBack" class="button button--base t-primary pd-regular radius-small flex flex-v-center gap-thin">
          <Icon name="arrow" class="i-regular rotate-180" />
          <span>Go back</span>
        </button>
      </div>

      <!-- <div class="pd-t-medium  w-max-25r">
        <span class="caption opacity-50 t-upper t-500 ls-wide d-block mn-b-small">Search Documentation</span>
        <div class="field-wrapper bg-base flex flex-v-center radius-small pd-small gap-small">
          <Icon name="search" class="i-small opacity-50" />
          <input type="text" placeholder="e.g. Installation guide..." class="w-100  bd-none" />
        </div>
        <div class="flex gap-medium mn-t-small">
          <a href="#" class="flex flex-v-center gap-micro footnote opacity-50"><Icon name="info" class="i-small" /> Help Center</a>
          <a href="#" class="footnote opacity-50">API Status</a>
        </div>
      </div> -->

    </div>
  </div>
</template>

<style scoped>
input { border: none; outline: none; }
input::placeholder { color: rgba(var(--text-secondary), 0.4); }
</style>